export type UTMType = string

export interface UTMField {
  type: UTMType
  value: string
}

export interface UTMOption {
  labelKey: string
  label?: string
  value: UTMType
}

export const DEFAULT_UTM_OPTIONS: UTMOption[] = [
  { labelKey: 'shopass_analytics.utm_source', label: 'UTM Source', value: 'utm_source' },
  { labelKey: 'shopass_analytics.utm_medium', label: 'UTM Medium', value: 'utm_medium' },
  { labelKey: 'shopass_analytics.utm_campaign', label: 'UTM Campaign', value: 'utm_campaign' },
  { labelKey: 'shopass_analytics.utm_content', label: 'UTM Content', value: 'utm_content' }
]

export const DEFAULT_FIRST_UTM: UTMType = 'utm_source'

export type UTMFormValues = {
  utmFields: UTMField[]
}
